module.exports = __webpack_public_path__ + "static/media/arrowdown.50c753c3.svg";